import { KMCPermissions } from 'app-shared/kmc-shared/kmc-permissions/kmc-permissions';

export const KMCPermissionsRules: {
  customPermissionKeyToNameMapping: { [key: number]: string };
  requiredPermissionMapping: { [key: number]: KMCPermissions };
  linkedPermissionMapping: { [key: number]: KMCPermissions };
} = {
  customPermissionKeyToNameMapping: {
    [KMCPermissions.CUEPOINT_MANAGE]: 'cuePoint.MANAGE',
    [KMCPermissions.DROPFOLDER_CONTENT_INGEST_DROP_FOLDER_DELETE]: 'dropFolder.CONTENT_INGEST_DROP_FOLDER_DELETE',
    [KMCPermissions.DROPFOLDER_CONTENT_INGEST_DROP_FOLDER_MATCH]: 'dropFolder.CONTENT_INGEST_DROP_FOLDER_MATCH',
    [KMCPermissions.DROPFOLDER_CONTENT_INGEST_DROP_FOLDER_BASE]: 'dropFolder.CONTENT_INGEST_DROP_FOLDER_BASE',
  },
  requiredPermissionMapping: {
    [KMCPermissions.CONTENT_INGEST_REMOTE_STORAGE]: KMCPermissions.FEATURE_REMOTE_STORAGE_INGEST,
    [KMCPermissions.DROPFOLDER_CONTENT_INGEST_DROP_FOLDER_MATCH]: KMCPermissions.CONTENT_INGEST_DROP_FOLDER_MATCH,
    [KMCPermissions.LIVE_STREAM_ADD]: KMCPermissions.FEATURE_LIVE_STREAM,
    [KMCPermissions.CONTENT_MANAGE_CUSTOM_DATA]: KMCPermissions.METADATA_PLUGIN_PERMISSION,
    [KMCPermissions.CONTENT_MANAGE_ENTRY_USERS]: KMCPermissions.FEATURE_END_USER_MANAGE,
    [KMCPermissions.CONTENT_INGEST_INTO_READY]: KMCPermissions.FEATURE_ENTRY_REPLACEMENT,
    [KMCPermissions.CONTENT_INGEST_REPLACE]: KMCPermissions.FEATURE_ENTRY_REPLACEMENT_APPROVAL,
    [KMCPermissions.CONTENT_INGEST_CLIP_MEDIA]: KMCPermissions.FEATURE_CLIP_MEDIA,
    [KMCPermissions.CONTENT_MANAGE_CATEGORY_USERS]: KMCPermissions.FEATURE_ENTITLEMENT,
    [KMCPermissions.LIVE_STREAM_UPDATE]: KMCPermissions.FEATURE_LIVE_STREAM,
    [KMCPermissions.CUEPOINT_MANAGE]: KMCPermissions.ADCUEPOINT_PLUGIN_PERMISSION,
    [KMCPermissions.CAPTION_MODIFY]: KMCPermissions.CAPTION_PLUGIN_PERMISSION,
    [KMCPermissions.ATTACHMENT_MODIFY]: KMCPermissions.ATTACHMENT_PLUGIN_PERMISSION,
    [KMCPermissions.CONTENT_MODERATE_CUSTOM_DATA]: KMCPermissions.METADATA_PLUGIN_PERMISSION,
    [KMCPermissions.CONTENT_MANAGE_DISTRIBUTION_BASE]: KMCPermissions.CONTENTDISTRIBUTION_PLUGIN_PERMISSION,
    [KMCPermissions.CONTENT_MANAGE_DISTRIBUTION_WHERE]: KMCPermissions.CONTENTDISTRIBUTION_PLUGIN_PERMISSION,
    [KMCPermissions.CONTENT_MANAGE_DISTRIBUTION_SEND]: KMCPermissions.CONTENTDISTRIBUTION_PLUGIN_PERMISSION,
    [KMCPermissions.CONTENT_MANAGE_DISTRIBUTION_REMOVE]: KMCPermissions.CONTENTDISTRIBUTION_PLUGIN_PERMISSION,
    [KMCPermissions.DROPFOLDER_CONTENT_INGEST_DROP_FOLDER_BASE]: KMCPermissions.DROPFOLDER_PLUGIN_PERMISSION,
    [KMCPermissions.DROPFOLDER_CONTENT_INGEST_DROP_FOLDER_DELETE]: KMCPermissions.DROPFOLDER_PLUGIN_PERMISSION,
    [KMCPermissions.ADVERTISING_UPDATE_SETTINGS]: KMCPermissions.FEATURE_VAST,
    [KMCPermissions.ANALYTICS_BASE]: KMCPermissions.FEATURE_ANALYTICS_TAB,
    [KMCPermissions.CUSTOM_DATA_PROFILE_BASE]: KMCPermissions.METADATA_PLUGIN_PERMISSION,
    [KMCPermissions.CUSTOM_DATA_PROFILE_ADD]: KMCPermissions.METADATA_PLUGIN_PERMISSION,
    [KMCPermissions.CUSTOM_DATA_PROFILE_UPDATE]: KMCPermissions.METADATA_PLUGIN_PERMISSION,
    [KMCPermissions.CUSTOM_DATA_PROFILE_DELETE]: KMCPermissions.METADATA_PLUGIN_PERMISSION,
    [KMCPermissions.ADMIN_USER_BULK]: KMCPermissions.FEATURE_END_USER_MANAGE,
  },
  linkedPermissionMapping: {
    [KMCPermissions.ACCESS_CONTROL_ADD]: KMCPermissions.ACCESS_CONTROL_BASE,
    [KMCPermissions.ACCESS_CONTROL_DELETE]: KMCPermissions.ACCESS_CONTROL_BASE,
    [KMCPermissions.ACCESS_CONTROL_UPDATE]: KMCPermissions.ACCESS_CONTROL_BASE,
    [KMCPermissions.ACCOUNT_UPDATE_SETTINGS]: KMCPermissions.ACCOUNT_BASE,
    [KMCPermissions.ADMIN_ROLE_ADD]: KMCPermissions.ADMIN_BASE,
    [KMCPermissions.ADMIN_ROLE_DELETE]: KMCPermissions.ADMIN_BASE,
    [KMCPermissions.ADMIN_ROLE_UPDATE]: KMCPermissions.ADMIN_BASE,
    [KMCPermissions.ADMIN_USER_ADD]: KMCPermissions.ADMIN_BASE,
    [KMCPermissions.ADMIN_USER_BULK]: KMCPermissions.ADMIN_BASE,
    [KMCPermissions.ADMIN_USER_DELETE]: KMCPermissions.ADMIN_BASE,
    [KMCPermissions.ADMIN_USER_UPDATE]: KMCPermissions.ADMIN_BASE,
    [KMCPermissions.ATTACHMENT_MODIFY]: KMCPermissions.CONTENT_MANAGE_BASE,
    [KMCPermissions.BULK_LOG_DELETE]: KMCPermissions.BULK_LOG_BASE,
    [KMCPermissions.BULK_LOG_DOWNLOAD]: KMCPermissions.BULK_LOG_BASE,
    [KMCPermissions.CAPTION_MODIFY]: KMCPermissions.CONTENT_MANAGE_BASE,
    [KMCPermissions.CONTENT_INGEST_BULK_UPLOAD]: KMCPermissions.CONTENT_INGEST_BASE,
    [KMCPermissions.CONTENT_INGEST_CLIP_MEDIA]: KMCPermissions.CONTENT_MANAGE_BASE,
    [KMCPermissions.CONTENT_INGEST_EXTERNAL_SEARCH]: KMCPermissions.CONTENT_INGEST_BASE,
    [KMCPermissions.CONTENT_INGEST_INTO_ORPHAN]: KMCPermissions.CONTENT_MANAGE_BASE,
    [KMCPermissions.CONTENT_INGEST_INTO_READY]: KMCPermissions.CONTENT_MANAGE_BASE,
    [KMCPermissions.CONTENT_INGEST_ORPHAN_AUDIO]: KMCPermissions.CONTENT_INGEST_BASE,
    [KMCPermissions.CONTENT_INGEST_ORPHAN_VIDEO]: KMCPermissions.CONTENT_INGEST_BASE,
    [KMCPermissions.CONTENT_INGEST_REFERENCE_MODIFY]: KMCPermissions.CONTENT_MANAGE_BASE,
    [KMCPermissions.CONTENT_INGEST_REMOTE_STORAGE]: KMCPermissions.CONTENT_INGEST_BASE,
    [KMCPermissions.CONTENT_INGEST_REPLACE]: KMCPermissions.CONTENT_MANAGE_BASE,
    [KMCPermissions.CONTENT_INGEST_UPLOAD]: KMCPermissions.CONTENT_INGEST_BASE,
    [KMCPermissions.CONTENT_INGEST_WEBCAM]: KMCPermissions.CONTENT_INGEST_BASE,
    [KMCPermissions.CONTENT_MANAGE_ACCESS_CONTROL]: KMCPermissions.CONTENT_MANAGE_BASE,
    [KMCPermissions.CONTENT_MANAGE_ASSIGN_CATEGORIES]: KMCPermissions.CONTENT_MANAGE_BASE,
    [KMCPermissions.CONTENT_MANAGE_CATEGORY_USERS]: KMCPermissions.CONTENT_MANAGE_BASE,
    [KMCPermissions.CONTENT_MANAGE_CUSTOM_DATA]: KMCPermissions.CONTENT_MANAGE_BASE,
    [KMCPermissions.CONTENT_MANAGE_DELETE]: KMCPermissions.CONTENT_MANAGE_BASE,
    [KMCPermissions.CONTENT_MANAGE_DISTRIBUTION_REMOVE]: KMCPermissions.CONTENT_MANAGE_DISTRIBUTION_BASE,
    [KMCPermissions.CONTENT_MANAGE_DISTRIBUTION_SEND]: KMCPermissions.CONTENT_MANAGE_DISTRIBUTION_BASE,
    [KMCPermissions.CONTENT_MANAGE_DISTRIBUTION_WHERE]: KMCPermissions.CONTENT_MANAGE_DISTRIBUTION_BASE,
    [KMCPermissions.CONTENT_MANAGE_DOWNLOAD]: KMCPermissions.CONTENT_MANAGE_BASE,
    [KMCPermissions.CONTENT_MANAGE_EDIT_CATEGORIES]: KMCPermissions.CONTENT_MANAGE_BASE,
    [KMCPermissions.CONTENT_MANAGE_EMBED_CODE]: KMCPermissions.CONTENT_MANAGE_BASE,
    [KMCPermissions.CONTENT_MANAGE_ENTRY_USERS]: KMCPermissions.CONTENT_MANAGE_BASE,
    [KMCPermissions.CONTENT_MANAGE_METADATA]: KMCPermissions.CONTENT_MANAGE_BASE,
    [KMCPermissions.CONTENT_MANAGE_RECONVERT]: KMCPermissions.CONTENT_MANAGE_BASE,
    [KMCPermissions.CONTENT_MANAGE_SCHEDULE]: KMCPermissions.CONTENT_MANAGE_BASE,
    [KMCPermissions.CONTENT_MANAGE_THUMBNAIL]: KMCPermissions.CONTENT_MANAGE_BASE,
    [KMCPermissions.CONTENT_MODERATE_APPROVE_REJECT]: KMCPermissions.CONTENT_MODERATE_BASE,
    [KMCPermissions.CONTENT_MODERATE_CUSTOM_DATA]: KMCPermissions.CONTENT_MODERATE_BASE,
    [KMCPermissions.CONTENT_MODERATE_METADATA]: KMCPermissions.CONTENT_MODERATE_BASE,
    [KMCPermissions.CUEPOINT_MANAGE]: KMCPermissions.CONTENT_MANAGE_BASE,
    [KMCPermissions.CUSTOM_DATA_PROFILE_ADD]: KMCPermissions.CUSTOM_DATA_PROFILE_BASE,
    [KMCPermissions.CUSTOM_DATA_PROFILE_DELETE]: KMCPermissions.CUSTOM_DATA_PROFILE_BASE,
    [KMCPermissions.CUSTOM_DATA_PROFILE_UPDATE]: KMCPermissions.CUSTOM_DATA_PROFILE_BASE,
    [KMCPermissions.DROPFOLDER_CONTENT_INGEST_DROP_FOLDER_DELETE]:
      KMCPermissions.DROPFOLDER_CONTENT_INGEST_DROP_FOLDER_BASE,
    [KMCPermissions.DROPFOLDER_CONTENT_INGEST_DROP_FOLDER_MATCH]: KMCPermissions.CONTENT_INGEST_BASE,
    [KMCPermissions.INTEGRATION_UPDATE_SETTINGS]: KMCPermissions.INTEGRATION_BASE,
    [KMCPermissions.LIVE_STREAM_ADD]: KMCPermissions.CONTENT_INGEST_BASE,
    [KMCPermissions.LIVE_STREAM_UPDATE]: KMCPermissions.CONTENT_MANAGE_BASE,
    [KMCPermissions.PLAYLIST_ADD]: KMCPermissions.PLAYLIST_BASE,
    [KMCPermissions.PLAYLIST_DELETE]: KMCPermissions.PLAYLIST_BASE,
    [KMCPermissions.PLAYLIST_EMBED_CODE]: KMCPermissions.PLAYLIST_BASE,
    [KMCPermissions.PLAYLIST_UPDATE]: KMCPermissions.PLAYLIST_BASE,
    [KMCPermissions.STUDIO_ADD_UICONF]: KMCPermissions.STUDIO_BASE,
    [KMCPermissions.STUDIO_DELETE_UICONF]: KMCPermissions.STUDIO_BASE,
    [KMCPermissions.STUDIO_SELECT_CONTENT]: KMCPermissions.STUDIO_BASE,
    [KMCPermissions.STUDIO_UPDATE_UICONF]: KMCPermissions.STUDIO_BASE,
    [KMCPermissions.SYNDICATION_ADD]: KMCPermissions.SYNDICATION_BASE,
    [KMCPermissions.SYNDICATION_DELETE]: KMCPermissions.SYNDICATION_BASE,
    [KMCPermissions.SYNDICATION_UPDATE]: KMCPermissions.SYNDICATION_BASE,
    [KMCPermissions.TRANSCODING_ADD]: KMCPermissions.TRANSCODING_BASE,
    [KMCPermissions.TRANSCODING_DELETE]: KMCPermissions.TRANSCODING_BASE,
    [KMCPermissions.TRANSCODING_UPDATE]: KMCPermissions.TRANSCODING_BASE,
  },
};
